import { render } from "./Uf.vue?vue&type=template&id=7f25eb3a&scoped=true"
import script from "./Uf.vue?vue&type=script&lang=js"
export * from "./Uf.vue?vue&type=script&lang=js"

import "./Uf.vue?vue&type=style&index=0&id=7f25eb3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f25eb3a"]])

export default __exports__